"use strict";
// import React from "react";
// import Modal from "react-bootstrap/Modal";
// import { animatedComponents, FormError, Input } from "../../../Shared/Input";
// import Select from "react-select";
// import UseAddTarifPeage from "../requestForm/UseAddTarifPeage";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// function AddOrUpdateTariffModal({
//     show,
//     handleClose,
//     item,
// }: {
//     show: boolean;
//     handleClose: () => void;
//     item?: any;
// }) {
//     const {
//         register,
//         errors,
//         onSubmit,
//         isLoading,
//         reset,
//         typeVehicule,
//         handleTypeVehiculeChange,
//         typeVehiculeOptions,
//         tollPoint,
//         handleTollPointChange,
//         tollPointOptions,
//     } = UseAddTarifPeage(handleClose, item);
//     return (
//         <Modal show={show} onHide={handleClose} className="custom__modal">
//             <Modal.Header className="modal-header-wrapper" closeButton>
//                 <Modal.Title className="modal-title-custom">
//                     {!!item ? "Modifier" : "Ajouter"} un tarif
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <div className="form-wrapper">
//                     <form onSubmit={onSubmit}>
//                         <div className="form-content">
//                             <div className="row infos-row">
//                                 <div className="col-md-12 mb-3 custom-wrapper">
//                                     <label
//                                         htmlFor="__category"
//                                         className="form-label form-label-formule"
//                                     >
//                                         Catégorie
//                                     </label>
//                                     <Select
//                                         id="__type"
//                                         options={typeVehiculeOptions}
//                                         defaultValue={typeVehiculeOptions.filter(
//                                             (option) =>
//                                                 option.value === typeVehicule
//                                         )}
//                                         closeMenuOnSelect={true}
//                                         components={animatedComponents}
//                                         placeholder="Type de véhicule"
//                                         onChange={handleTypeVehiculeChange}
//                                     />
//                                     <FormError
//                                         error={
//                                             errors?.vehicule_type_id?.message
//                                         }
//                                     />
//                                 </div>
//                                 <div className="col-md-12 mb-3 custom-wrapper">
//                                     <label
//                                         htmlFor="__tool_point"
//                                         className="form-label form-label-formule"
//                                     >
//                                         Point de péage
//                                     </label>
//                                     <Select
//                                         id="__type"
//                                         options={tollPointOptions}
//                                         defaultValue={tollPointOptions.filter(
//                                             (option) =>
//                                                 option.value === tollPoint
//                                         )}
//                                         closeMenuOnSelect={true}
//                                         components={animatedComponents}
//                                         placeholder="Choisir un point"
//                                         onChange={handleTollPointChange}
//                                     />
//                                     <FormError
//                                         error={errors?.toll_point_id?.message}
//                                     />
//                                 </div>
//                                 <div className="col-md-12 mb-3 custom-wrapper">
//                                     <Input
//                                         label="Montant"
//                                         type="text"
//                                         id="__amount"
//                                         placeholder="Entrer un montant"
//                                         {...register("price")}
//                                         error={errors?.price}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="btn-wrapper d-flex justify-content-end gap-3 mt-5">
//                             <button
//                                 type="button"
//                                 className="btn cancel__btn custom"
//                                 onClick={() => {
//                                     handleClose()
//                                     reset()
//                                 }}
//                             >
//                                 Annuler
//                             </button>
//                             <button
//                                 type="submit"
//                                 className="sunu-autoroute-admin-btn-add custom"
//                                 disabled={isLoading}
//                             >
//                                 {isLoading ? (
//                                     <div className="d-flex align-items-center gap-2">
//                                         <i className="fa fa-spinner fa-spin "></i>
//                                         <span>
//                                             {!!item
//                                                 ? "Modification..."
//                                                 : "Enregistrement..."}
//                                         </span>
//                                     </div>
//                                 ) : item ? (
//                                     "Modifier"
//                                 ) : (
//                                     "Enregistrer"
//                                 )}
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }
// export default AddOrUpdateTariffModal;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const UseAddTarifPeage_1 = __importDefault(require("../requestForm/UseAddTarifPeage"));
const Input_1 = require("../../../Shared/Input");
const fa_1 = require("react-icons/fa");
const ci_1 = require("react-icons/ci");
function AddOrUpdateTariffModal({ show, handleClose, }) {
    const { register, errors, onSubmit, isLoading, fields, append, remove, control, typeVehiculeOptions, tollPointOptions, } = (0, UseAddTarifPeage_1.default)(handleClose);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: handleClose, className: "custom__modal", size: "lg" },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { className: "modal-header-wrapper", closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, { className: "modal-title-custom" }, "Ajouter plusieurs tarifs")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("form", { onSubmit: onSubmit },
                fields.map((field, index) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return (react_1.default.createElement("div", { key: field.id, className: "row mb-3 p-3 custom-border position-relative" },
                        react_1.default.createElement("div", { className: "col-md-4" },
                            react_1.default.createElement("label", { className: "form-label form-label-formule" }, "Type de v\u00E9hicule"),
                            react_1.default.createElement("select", Object.assign({ className: "form-control form-control-input-formule" }, register(`pricings.${index}.vehicule_type_id`)),
                                react_1.default.createElement("option", { value: "" }, "S\u00E9lectionner"),
                                typeVehiculeOptions.map((opt) => (react_1.default.createElement("option", { key: opt.value, value: opt.value }, opt.label)))),
                            react_1.default.createElement(Input_1.FormError, { error: (_c = (_b = (_a = errors === null || errors === void 0 ? void 0 : errors.pricings) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.vehicule_type_id) === null || _c === void 0 ? void 0 : _c.message })),
                        react_1.default.createElement("div", { className: "col-md-4" },
                            react_1.default.createElement("label", { className: "form-label form-label-formule" }, "Poste de p\u00E9age"),
                            react_1.default.createElement("select", Object.assign({ className: "form-control form-control-input-formule" }, register(`pricings.${index}.toll_point_id`)),
                                react_1.default.createElement("option", { value: "" }, "S\u00E9lectionner"),
                                tollPointOptions.map((opt) => (react_1.default.createElement("option", { key: opt.value, value: opt.value }, opt.label)))),
                            react_1.default.createElement(Input_1.FormError, { error: (_f = (_e = (_d = errors === null || errors === void 0 ? void 0 : errors.pricings) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.toll_point_id) === null || _f === void 0 ? void 0 : _f.message })),
                        react_1.default.createElement("div", { className: "col-md-4" },
                            react_1.default.createElement("label", { className: "form-label form-label-formule" }, "Montant"),
                            react_1.default.createElement("input", Object.assign({ type: "number", step: "0.01", placeholder: "Ex: 1500", className: "form-control form-control-input-formule" }, register(`pricings.${index}.price`))),
                            react_1.default.createElement(Input_1.FormError, { error: (_j = (_h = (_g = errors === null || errors === void 0 ? void 0 : errors.pricings) === null || _g === void 0 ? void 0 : _g[index]) === null || _h === void 0 ? void 0 : _h.price) === null || _j === void 0 ? void 0 : _j.message })),
                        fields.length > 1 && (react_1.default.createElement("div", { className: "col-md-12 mt-1 d-flex justify-content-end" },
                            react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", style: { color: "#E53E3E" }, "data-tooltip-content": "Supprimer", onClick: () => remove(index) },
                                react_1.default.createElement(fa_1.FaTrash, null))))));
                }),
                react_1.default.createElement("div", { className: "col-md-12 d-flex justify-content-end mb-4 pe-3" },
                    react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-edit", "data-tooltip-content": "Ajouter un tarif", onClick: () => append({ price: "", toll_point_id: 0, vehicule_type_id: 0 }) },
                        react_1.default.createElement(ci_1.CiCirclePlus, { className: "edit-action-icon" }))),
                react_1.default.createElement("div", { className: "btn-wrapper d-flex justify-content-end gap-3 mt-4" },
                    react_1.default.createElement("button", { type: "button", className: "btn cancel__btn custom", onClick: handleClose }, "Annuler"),
                    react_1.default.createElement("button", { type: "submit", className: "sunu-autoroute-admin-btn-add custom", disabled: isLoading }, isLoading ? (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                        react_1.default.createElement("i", { className: "fa fa-spinner fa-spin " }),
                        react_1.default.createElement("span", null, "Enregistrement..."))) : ("Enregistrer")))))));
}
exports.default = AddOrUpdateTariffModal;
